module.exports = __webpack_public_path__ + "img/facebook.fb696eeb.png";